<template lang="pug">
  .registry.operator-update
    router-view
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
        .edit-select
          select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs.edit-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            .body.body-table.body-table--noBottomPadding
              .table-choose-panel
                .toolbar.toolbar_no-padding.toolbar_margin-bottom
                  .toolbar__line
                    .additional-panel
                      e-button(
                        v-if="fields.is_regional===true"
                        @click="openUnsetRO()"
                        label="Снять статус Рег. оператора"
                      ).reset-btn.button.button_green

                      e-button(
                        v-if="fields.is_regional!==true"
                        @click="openSetRO()"
                        label="Назначить рег. оператором"
                      ).reset-btn.button.button_green
            e-modal(
              v-if="showModalSetRO"
              @close="cancelChangeStatus()"
              @confirm="setROStatus()"
              title="Добавление нового соглашения"
              :autoHeight="true"
            )
              slot
                .modal__row
                  .modal__col
                    e-form-group(
                      name="agreement_num"
                      inputType="input"
                      label="Соглашение №"
                      :model="fields"
                      :required="true"
                      tabView="tab1"
                      modalVariableName="showModalSetRO"
                    )
                    div.col-block
                      div.half-blocks
                        e-form-group(
                          name="agreement_from"
                          inputType="calendar"
                          formGroupStyle="half-block"
                          label="От"
                          :model="fields"
                          :required="true"
                          tabView="tab1"
                          type="date"
                          modalVariableName="showModalSetRO"
                        )
                        e-form-group(
                          name="agreement_to"
                          inputType="calendar"
                          formGroupStyle="half-block"
                          label="До"
                          :model="fields"
                          :required="true"
                          tabView="tab1"
                          type="date"
                          modalVariableName="showModalSetRO"
                        )


            e-modal(v-if="showModalRemoveROStatusConfirmation"
              @close="cancelChangeStatus()"
              @confirm="unsetROStatus()"
              :autoHeight="true"
            )
              slot
                .modal__row
                  .modal__col
                    div.col-block
                      div.info Снять статус регионального оператора с хозяйствующего субъекта? Вкладка "Зоны деятельности" и информация об Единном тарифе станут недоступны.
            .modal__row
              .modal__col
                e-form-group(
                  name="name"
                  inputType="name"
                  label="Наименование"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="short_name"
                  inputType="name"
                  label="Сокращенное наименование"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="ogrn"
                  inputType="ogrn"
                  label="ОГРН/ОГРНИП"
                  validationRule="number"
                  :model="fields"
                  tabView="tab1"
                  :onChangeValidation="true"
                  :onChangeValidationOptions="{disableAutoFocus: true}"
                  :validationAdditionalRules="{specialValidate: validateOgrn}"
                )
                e-form-group(
                  name="inn"
                  inputType="inn"
                  label="ИНН"
                  validationRule="number"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="kpp"
                  inputType="input"
                  label="КПП"
                  validationRule="number"
                  :model="fields"
                  tabView="tab1"
                  :onChangeValidation="true"
                  :onChangeValidationOptions="{disableAutoFocus: true}"
                  :validationAdditionalRules="{minLen: 9, maxLen: 9}"
                )
                e-form-group(
                  name="legal_address"
                  inputType="address"
                  label="Юридический адрес"
                  :model="fields"
                  tabView="tab1"
                  addressIdFieldName="legal_address_id"
                  :addressData="addressData"
                )
                e-form-group(
                  name="status_id"
                  inputType="select"
                  :required="true"
                  label="Статус объекта"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="close_date"
                  inputType="calendar"
                  label="Дата закрытия"
                  :model="fields"
                  tabView="tab1"
                  type="date"
                  :disabled="fields.status_id !== notActive"
                )
                e-form-group(
                  v-if="hasReo"
                  name="reo_id"
                  inputType="input"
                  label="ППК РЭО ID"
                  :model="fields"
                  :required="false"
                  tabView="tab1"
                )
              .modal__col
                accordion
                  template(slot="header")
                    e-form-subtitle(text="Вид деятельности по ОКВЭД")
                  template(slot="body")
                    e-form-group(
                      name="code"
                      inputType="input"
                      label="ОКВЭД(номер)"
                      :model="fields.okved"
                      validateAlias="okved.code"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="okved_name_old"
                      inputType="input"
                      label="ОКВЭД(наименование)"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="business_category_id"
                      inputType="select"
                      label="Отношение к субъектам предпринимательства"
                      :model="fields"
                      tabView="tab1"
                      :options="business_categories"
                    )
                    e-form-group(
                      name="activity_description"
                      inputType="textarea"
                      label="Краткое описание деятельности"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      v-if="hasOkpoField"
                      name="okpo"
                      inputType="input"
                      label="ОКПО"
                      :model="fields"
                      tabView="tab1"
                    )
                accordion
                  template(slot="header")
                    e-form-subtitle(text="Руководитель")
                  template(slot="body")
                    e-form-group(
                      name="head_position"
                      inputType="input"
                      label="Должность"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="head_name"
                      inputType="input"
                      label="ФИО"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="head_phone"
                      inputType="input"
                      validationRule="phone"
                      label="Телефон"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="head_email"
                      inputType="input"
                      validationRule="email"
                      label="Email"
                      :model="fields"
                      tabView="tab1"
                    )

              .modal__col
                e-form-group(
                  v-if='hasOperatorRating'
                  name="rating"
                  inputType="select"
                  label="Оценка качества работы"
                  :model="fields"
                  tabView="tab1"
                  :options="ratingItems"
                )
                accordion
                  template(slot="header")
                    e-form-subtitle(:text="operatorLocationText")
                  template(slot="body")
                    e-location(
                      :formValidator="formValidator"
                      :model="fields"
                      name="fact_address"
                      addressIdFieldName="fact_address_id"
                      :required="true"
                      :addressData="addressData"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="photoPreview"
                      inputType="simple-file-uploader"
                      label="Фотография"
                      :model="fields"
                      tabView="tab1"
                      :uploadUrl="uploadUrl"
                      @fileUploaded="photoUploaded"
                      @fileRemoved="photoRemoved"
                      :showFilePreview="true"
                    )

                accordion
                  template(slot="header")
                    e-form-subtitle(text="Ответственный за экологию")
                  template(slot="body")
                    e-form-group(
                      name="eco_position"
                      inputType="input"
                      label="Должность"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="eco_name"
                      inputType="input"
                      label="ФИО"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="eco_phone"
                      inputType="input"
                      label="Телефон"
                      validationRule="phone"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="eco_email"
                      inputType="input"
                      validationRule="email"
                      label="Email"
                      :model="fields"
                      tabView="tab1"
                    )

          // ЛИЦЕНЗИЯ
          .body-flex(v-show="tabView === 'tab2'")
            .modal__row
              .modal__col
                e-form-group(
                  name="license_number"
                  inputType="input"
                  label="Лицензия №"
                  :model="fields"
                  tabView="tab2"
                )
                e-form-group(
                  name="license_start_date"
                  inputType="calendar"
                  label="От"
                  :model="fields"
                  tabView="tab2"
                  type="date"
                )
                e-form-group(
                  name="license_finish_date"
                  inputType="calendar"
                  label="До"
                  :model="fields"
                  tabView="tab2"
                  type="date"
                  :disabled="fields.term"
                )
                div.col-block
                  label.custom-checkbox
                    input.visually-hidden.custom-checkbox__input(
                      type="checkbox"
                      v-model="fields.term"
                    )
                    span.custom-checkbox__block
                    span.custom-checkbox__text Бессрочная

              .modal__col
                e-form-group(
                  name="actions"
                  :model="fields"
                  label="Классы опасности по видам деятельности"
                  tabView="tab2"
                  :required="false"
                )
                  slot
                    .full-width.table.table_classes
                      .table__header
                        .table__row
                          .table__col.table__head(style="min-width: 180px; max-width: 180px")
                          .table__col.table__head.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center I
                          .table__col.table__head.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center II
                          .table__col.table__head.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center III
                          .table__col.table__head.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center IV
                          .table__col.table__head.table__col_fourth-col.table__col_min-width-auto.table_col_no-border.table__col_justify-center V
                      .table__body
                        .table__row(
                          v-for="action in actionsTable"
                        )
                          .table__col(style="min-width: 180px; max-width: 180px") {{ action.desc }}
                          .table__col.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center
                            label.checked
                              input.checkbox(type="checkbox" value="1" v-model="action.danger")
                              span
                          .table__col.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center
                            label.checked
                              input.checkbox(type="checkbox" value="2" v-model="action.danger")
                              span
                          .table__col.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center
                            label.checked
                              input.checkbox(type="checkbox" value="3" v-model="action.danger")
                              span
                          .table__col.table__col_fourth-col.table__col_min-width-auto.table__col_justify-center
                            label.checked
                              input.checkbox(type="checkbox" value="4" v-model="action.danger")
                              span
                          .table__col.table__col_fourth-col.table__col_min-width-auto.table_col_no-border.table__col_justify-center
                            label.checked
                              input.checkbox(type="checkbox" value="5" v-model="action.danger")
                              span
              .modal__col
                // uncomment for enable multiupoder
                //e-form-group(name="files" label="Лицензия" :model="fields" tabView="tab2")
                  slot
                    e-file-uploader(:entityId="$route.params.id" ref="fileUploader")
                e-form-group(
                  name="filePreview"
                  inputType="simple-file-uploader"
                  label="Лицензия"
                  :model="fields"
                  tabView="tab2"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

          // ЗОНЫ ДЕЙСТВИЯ
          .body-flex(v-show="tabView === 'tab3' && (!!fields.is_regional) === true")
            .body.body-table
              div.table-choose-panel
                div.toolbar.toolbar_no-padding
                  div.line
                    div.semibold Соглашение об организации деятельности по обращению с ТКО
                  .modal__row
                    e-form-group(
                      name="agreement_num"
                      inputType="input"
                      label="Соглашение №"
                      :model="fields"
                      :required="fields.is_regional===true"
                      tabView="tab3"
                    )
                    e-form-group(
                      name="agreement_from"
                      inputType="calendar"
                      label="От"
                      type="date"
                      :model="fields"
                      :required="fields.is_regional===true"
                      tabView="tab3"
                    )
                    e-form-group(
                      name="agreement_to"
                      inputType="calendar"
                      label="Действует до"
                      :model="fields"
                      type="date"
                      :required="fields.is_regional===true"
                      tabView="tab3"
                    )

              municipalities-with-zones(
                :fields="fields"
                tabView="tab3"
              )
              municipalities-with-operators(
                :fields="fields"
                tabView="tab3"
              )

          // ЗОНЫ ТРАНСПОРТИРОВАНИЯ
          .body-flex(v-show="tabView === 'tab11' && (!fields.is_regional) === true")
            div.body.body-table
              div.table-choose-panel
                transportation-with-zones(
                  :fields="fields"
                  tabView="tab11"
                )

          // ЗАКАЗЧИКИ
          .body-flex(v-show="tabView === 'tab4'")
            operator-customers(
              :fields="fields"
              @saved="innerUpdated"
              @delete="innerUpdated"
            )

          // ОБЪЕКТЫ ОБРАЩЕНИЯ
          .body-flex(v-show="tabView === 'tab5'")
            r-operator-objects-table(
              ref="operatorObjectsTable"
              :id="fields.id"
              :fields="fields"
              @saved="innerUpdated"
              @delete="innerUpdated"
            )

          // отходы
          .body-flex(v-if="tabView === 'tab8'")
            operator-transport-waste(v-if='hasOperatorTransportWaste' )
            r-registry-operator-garbage-table(
              v-else
              :id="fields.id"
            )
          // only for some regions
          .body-flex(v-if="tabView === 'transport'")
            transport-table(
              :id="fields.id"
              :fields="fields"
            )

          // ТАРИФЫ
          tko-tariff(
            v-show="tabView === 'tab6'"
            :tkoOperatorTariffs="fields.tkoOperatorTariffs"
            ref="tkoTariff"
            :TARIFFS="TARIFFS"
            :hide-calc="true"
          )

          // ИНВЕСТ ПРОГРАММА
          .body-flex(v-show="tabView === 'tab7'")
            div.body.body-table
              .modal__row.modal__row_fourth
                e-form-group(
                  name="invest_num"
                  inputType="input"
                  validationRule="number"
                  label="Номер приказа Министерства"
                  :model="fields"
                  tabView="tab7"
                )
                e-form-group(
                  name="invest_from"
                  inputType="calendar"
                  label="От"
                  :model="fields"
                  type="date"
                  tabView="tab7"
                )
                e-form-group(
                  name="invest_to"
                  inputType="calendar"
                  label="Действует до"
                  :model="fields"
                  tabView="tab7"
                  type="date"
                )
                div(style="align-self: flex-end; margin-bottom: 20px")
                  e-button(@click.prevent="changeInvestValidate() ? showModalSmallInvest = !showModalSmallInvest : ''" label="Сохранить").reset-btn.button.button_green

              div.toolbar-table
                div.semibold Финансирование инвестиционной программы, в тыс.руб
                div.toolbar.toolbar--modal

              .table#invest
                table(style="min-width: 100%")
                  thead
                    tr
                      th.table__th(style="text-align: left;") Источник финансирования
                      th.table__th(v-for="(item, key) in tkoOperatorInvestsByYear" :key="key") {{item.year}}
                  tbody
                    tr
                      td.table__td Сумма собственных средств оператора
                      td.table__td(v-for="(item, key) in tkoOperatorInvestsByYear" :key="key")
                        input.input(
                          @input="updateSummary(item)"
                          type="text"
                          v-model="item.self_resources"
                        )
                    tr
                      td.table__td Сумма средств бюджетов БС РФ
                      td.table__td(v-for="(item, key) in tkoOperatorInvestsByYear" :key="key")
                        input.input(
                          @input="updateSummary(item)"
                          type="text"
                          v-model="item.gos_resources"
                        )
                    tr
                      td.table__td Всего средств
                      td.table__td(v-for="(item, key) in tkoOperatorInvestsByYear" :key="key")
                        input.input(
                          v-e-element-rerender="updateSummary(item)"
                          type="text"
                          :disabled="true"
                          v-model="item.summary"
                        )

            e-modal(
              v-if="showModalSmallInvest"
              @close="showModalSmallInvest = false"
              @confirm="changeInvest()"
              :autoHeight="true"
            )
              slot
                div.body
                  div.col
                    div.col-block
                      div.info Изменение периода действия Инвестиционного Соглашения может повлиять на количество столбцов в таблице. Информация о финансировании может быть удалена. Сохранить новые реквизиты?

          .body-flex(v-show="tabView === 'requiredQuantity'")
            .line
              e-button-add(
                btnDefaultClass="actions-panel__button btn-add button button_add button_icon"
                @click="showAddOperator=true"
                title="Добавить целевой показатель"
              )
              e-button-add(
                @click="addNewCol({})"
                label="Добавить столбец"
                btnDefaultClass=" "
              ).actions-panel__button.btn-text
              e-button-delete(
                btnDefaultClass="e-button-delete row-delete"
                v-show="checkedRows"
                @click="deleteOperatorItem"
                title="Поставьте галочку напротив целевого показателя в таблице и нажмите сюда чтобы его отредактировать"
              )
            target-update(
              v-if="showAddOperator"
              :isFromOperator="true"
              @closeModalOperator="closeModalOperator"
            )
            .table.tscroll.table--forEdit.table_operator
              table(cellspacing="0" ref="tableHeader")
                colgroup
                  template(v-for="(row, rowKey, index) in rows")
                    template(v-if="index === 0")
                      col(
                        v-for="col in row"
                        :width="col.width"
                      )
                thead
                  tr(v-for="headerRow in tableHeaders")
                    th(
                      v-for="(headerCol, headerIndex) in headerRow"
                      :colspan="headerCol.colspan"
                      :rowspan="headerCol.rowspan"
                      :class="`field-${headerIndex} th-${headerCol.colspan || 0}-${headerCol.rowspan || 0}`"
                    ) {{headerCol.value}}
                      e-button-delete(
                        v-if="headerCol.columnEmpty === true"
                        @click="deleteEmptyColumn(headerCol.year)"
                      )
              e-perfect-scrollbar(
                ref="tablePS"
                :styles="scrollTableHeight"
                :emitTypes="['vue']"
                @ps-scroll-x="scrollHandler($event.event)"
                :config="{suppressScrollY: false, suppressScrollX: false}"
              )
                div.tbody-wrapper
                  table(cellspacing="0")
                    colgroup
                      template(v-for="(row, rowKey, index) in rows")
                        template(v-if="index === 0")
                          col(
                            v-for="col in row"
                            :width="col.width"
                          )
                    tbody(ref="tableBody")
                      tr(
                        v-for="row in rows"
                        :data-id="row[0].id"
                        :class="{'is-checked': (checkedRows === row[0].id)}"
                      )
                        td(
                          v-for="(col, colIndex) in row"
                          :title="colIndex > 2 ? 'Чтобы отредактировать значение используйте двойной клик' : 'Кликните по ряду и не отпуская кнопку мыши начните тянуть ряд вниз либо вверх чтобы сменить порядок'"
                        )
                          div.flex-row(v-if="colIndex===0")
                            div.sortable
                              div.arrows
                                span.up
                                span.down
                            div.number №&nbsp;{{col.value}}
                            label.radioButton.custom-radio
                              input.visually-hidden.custom-radio__input(
                                type="radio"
                                :value="col.id"
                                v-model="checkedRows"
                                @click="checkRow(col.id)"
                              ).radio
                              span.custom-radio__block

                          div(
                            v-if="!col._isEdit"
                            @dblclick="setEdit(col, colIndex)"
                            :title="colIndex > 3 ? 'Чтобы отредактировать значение используйте двойной клик' : 'Кликните по ряду и не отпуская кнопку мыши начните тянуть ряд вниз либо вверх чтобы сменить порядок'"
                          )
                            template(v-if="colIndex > 0")
                              template(v-if="col.value === null") -
                              template(v-else) {{col.value}}
                          div(
                            v-else
                            title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
                          ).edit
                            input(
                              type="text"
                              @blur="saveEdit(col)"
                              @keyup.enter.prevent="saveEdit(col)"
                              v-model="col.value"
                            )
                            span.invalid.error.table-invalid {{col._error}}

          // Журнал изменений
          .body-flex(v-show="tabView === 'tab9'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )

          // Документы
          .body-flex(v-show="tabView === 'tab10'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
          reports(
            v-if="tabView === 'reports'"
            :document-ids="documentIds"
            @documentsChanged="documentsChanged"
          )
</template>

<script>
import { core, indicator, tko } from '@/api/api-endpoints'
import TargetUpdate from '@/app/target/TargetUpdate'
import hasMixin from '@/mixins/has-mixin'
import textMixin from '@/mixins/text-mixin'
import targetMixin, { typeTable } from '@/mixins/targetMixin'
import operatorAllForm from './mixins/operator-all-form'
import OperatorCustomers from './components/operator-customers'
import MunicipalitiesWithZones from './components/municipalities-with-zones'
import TransportationWithZones from './components/transportation-with-zones'
import MunicipalitiesWithOperators from './components/municipalities-with-operators'
import TkoTariff from './components/tko-tariff'
import TransportTable from './components/transport-table'
import Reports from './components/reports'
import OperatorTransportWaste from './components/operator-transport-waste'

const ratingItems = [
  { id: '1.0', name: 1 },
  { id: '2.0', name: 2 },
  { id: '3.0', name: 3 },
  { id: '4.0', name: 4 },
  { id: '5.0', name: 5 },
]

export default {
  components: {
    TransportationWithZones,
    TkoTariff,
    MunicipalitiesWithZones,
    OperatorCustomers,
    TargetUpdate,
    TransportTable,
    MunicipalitiesWithOperators,
    Reports,
    OperatorTransportWaste,
  },
  mixins: [operatorAllForm, targetMixin, hasMixin, textMixin],
  data() {
    return {
      tabView: 'tab1',
      data: [],
      fields: {
        business_category_id: '',
        is_regional: false,
        coordinates: '0,0',
        latitude: '',
        longitude: '',
        mos: null,
      },
      lastYear: 2019,
      scrollTableHeight: { height: 'calc(100% - 137px)' },
      errors: null,
      requiredQuantity: [],
      hasDocumentField: false,
      showAddOperator: false,
      checkedRows: null,
      ratingItems,
    }
  },
  computed: {
    moduleId() {
      return this.moduleIds['tko-operator']
    },
    tabs() {
      const tabs = [{ tab1: 'Общие сведения' }]
      if (this.fields.is_regional === true) {
        tabs.push({ tab3: 'Зоны действия' })
      } else {
        tabs.push({ tab11: 'Зоны транспортирования' })
      }

      tabs.push({ tab2: 'Лицензия' })
      tabs.push({ tab6: 'Тарифы' })
      tabs.push({ tab7: 'Инвестиционная программа' })
      tabs.push({ tab4: 'Заказчики' })
      tabs.push({ tab5: 'Объекты обращения' })
      tabs.push({ tab8: 'Отходы' })
      if (this.hasOperatorAutopark) {
        tabs.push({ transport: 'Автопарк' })
      }
      if (this.hasRequiredQuantityTab) {
        tabs.push({ requiredQuantity: 'Необходимое количество' })
      }

      if (this.fields.id) {
        tabs.push({ tab9: 'Журнал изменений' })
      }
      tabs.push({ tab10: 'Документы' })

      if (this.hasRegOperatorReports) {
        tabs.push({ reports: 'Отчеты' })
      }
      return tabs
    },
    statuses() {
      return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint())
        ?.status
    },
  },
  methods: {
    uploadUrl() {
      return core.file()
    },
    getBusinessCategoriesEndpoint() {
      return core.statuses({ fields: 'business_category' })
    },
    getDeleteUrl(id) {
      return tko.operatorDelete(id)
    },
    getUpdateOrCreateUrl() {
      return tko.operatorUpdateOrCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return tko.operator(route.params.id)
    },
    getCollectionEndpoint() {
      return core.collection('status', { query: { type: 'tko_operator' } })
    },
    closeModalOperator() {
      this.showAddOperator = false
      this.getTableData().then(() => {
        this.rebuildRows()
      })
    },
    getEndpoint(route) {
      route.query.type_table = 3
      if (this.$route.params.id) {
        return indicator.objects(route)
      }
      return null
    },
    objectEmptyTableTypeYear(year, typeTable) {
      return indicator.objectEmptyTableTypeYear(year, typeTable, {
        query: { tko_operator_id: this.$route.params.id },
      })
    },
    getDeleteEmptyColumnUrl(year) {
      return indicator.objectDeleteEmptyYear(year, typeTable.OPERATOR_TABLE, {
        query: { tko_operator_id: this.$route.params.id },
      })
    },
    fetchData() {
      this.getTableData().then(() => {
        this.rebuildRows()
      })
    },
    async getTableData() {
      if (this.$route.params.id) {
        this.data = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: indicator.objects({
              query: {
                tko_operator_id: this.$route.params.id,
                type_table: typeTable.OPERATOR_TABLE,
              },
            }),
          })
        ).data
      }
    },
    async getMeasure() {
      await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: core.collection('measure', {
          query: {
            type: 'indicator',
          },
        }),
      })
    },
    async deleteOperatorItem() {
      await this.$store.dispatch('deleteModel', {
        url: indicator.objectDeleteWithOperator(
          this.checkedRows,
          this.$route.params.id
        ),
        endpoint: this.getItemEndpoint(this.$route),
      })
      this.getTableData().then(() => {
        this.rebuildRows()
      })
    },
    getObjectPlanFactUpdateUrl(id, year) {
      return indicator.objectPlanFactUpdate(id, year, {
        query: { tko_operator_id: this.$route.params.id },
      })
    },
    setEdits() {
      const findedObject = Object.values(this.rows).find(
        (item) => item[0].id === this.checkedRows
      )
      const EDITABLE_INDEX = 3
      for (let i = EDITABLE_INDEX; i < Object.keys(findedObject).length; i++) {
        this.setEdit(findedObject[i], i)
      }
    },
    changeEditSelect(event) {
      const val = this.tabs[event.target.selectedIndex]
      this.tabView = Object.keys(val)[0]
    },
  },
  created() {
    if (this.hasRequiredQuantityTab) {
      this.typeTable = 'OPERATOR_TABLE'
      this.getTableData().then(() => {
        this.rebuildRows()
      })
      this.getMeasure()
    }
  },
}
</script>
<style lang="scss" scoped>
.table_operator {
  height: calc(100vh - 167px - 161px);
  overflow-x: hidden !important;

  table {
    table-layout: fixed;
  }
}

table.full-width {
  width: 100%;
}

.main-layout .line {
  padding-top: 10px;
  padding-bottom: 10px !important;
}
</style>
